import { FormActions } from "seneca-common/utils/form/state/actionTypes";
import {
  ActionTypeRegisterField,
  ActionTypeResetErrors,
  ActionTypeSetFieldValue,
  ActionTypeSetFormErrors,
  ActionTypeSetFormFieldsErrors,
  ActionTypeSetFormLoading
} from "seneca-common/utils/form/state/types";

export function setFieldValueAction(payload: ActionTypeSetFieldValue) {
  return {
    type: FormActions.setFieldValue,
    payload
  };
}

export function setFormErrorsAction(payload: ActionTypeSetFormErrors) {
  return {
    type: FormActions.setFormErrors,
    payload
  };
}

export function registerFieldAction(payload: ActionTypeRegisterField) {
  return {
    type: FormActions.registerField,
    payload
  };
}

export function setFormLoadingAction(payload: ActionTypeSetFormLoading) {
  return {
    type: FormActions.setFormLoading,
    payload
  };
}

export function resetFormAction() {
  return {
    type: FormActions.resetFormState,
    payload: {}
  };
}

export function resetErrorsAction(payload: ActionTypeResetErrors) {
  return {
    type: FormActions.resetErrors,
    payload
  };
}

export function setFieldErrorsAction(payload: ActionTypeSetFormFieldsErrors) {
  return {
    type: FormActions.setFieldErrors,
    payload
  };
}
